import React from 'react';
import RoomShellSheet from './RoomShellSheet';
import { RsIcon } from './roomShellStyle';
import { WHO_LABEL, COST_LABEL } from '../../utils/roomPanels';

// ➕ The "+ Add a tool" shelf (SPACES_REDESIGN_BRAINSTORM_2026_09_29 §5.6; the
// toolkit mockup's tile: name, one line, who can use it, what it costs).
// It lists the registry panels this room may use that no rail holds yet, and
// only those the page can really draw (no fake tools). Add puts one at the
// end of the rail whose "+" opened the shelf (on phones: its own default
// side), on THIS device. Every v1 panel is free.
//
//   tools     roomPanels rows (already filtered: unplaced + available)
//   side      'left' | 'right' | null (phones)
//   onAdd     (id) => void
//   onReset   () => void, or null when the layout is already the room's own

const SIDE_SUB = { left: 'To the left side', right: 'To the right side' };

export default function ToolShelf({
  open, onClose, tools = [], side = null, onAdd, onReset = null, isMobile = false, mode = 'dark', accent = null,
}) {
  return (
    <RoomShellSheet
      open={open}
      onClose={onClose}
      title="Add a tool"
      sub={isMobile ? 'To this phone' : (SIDE_SUB[side] || null)}
      isMobile={isMobile}
      mode={mode}
      accent={accent}
      kind="shelf"
      testId="rs-shelf"
      footer={(
        <>
          <span className="rs-fine">Your layout stays on this device.</span>
          {onReset ? (
            <button type="button" className="rs-lnk" data-prop-ui="" data-rs-reset="" onClick={onReset}>Reset</button>
          ) : null}
        </>
      )}
    >
      {tools.length ? (
        <div role="list" aria-label="Tools you can add">
          {tools.map((t) => (
            <div className="rs-tool" role="listitem" key={t.id} data-rs-tool={t.id}>
              <span className="rs-toolic" aria-hidden="true"><RsIcon name={t.icon} size={18} /></span>
              <div className="rs-tooltx">
                <b>{t.label}</b>
                <span>{t.blurb}</span>
                <div className="rs-marks">
                  <span className="rs-mark" data-who={t.who}>{t.who === 'ai' ? <i aria-hidden="true" /> : null}{WHO_LABEL[t.who] || WHO_LABEL.people}</span>
                  <span className="rs-mark" data-cost={t.cost}>{COST_LABEL[t.cost] || COST_LABEL.free}</span>
                </div>
              </div>
              <button type="button" className="rs-addb" data-prop-ui="" aria-label={`Add ${t.label}`} onClick={() => onAdd && onAdd(t.id)}>
                <RsIcon name="plus" size={14} stroke={2.6} />Add
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="rs-none" data-rs-shelf-empty="">Every tool is already in this room.</div>
      )}
    </RoomShellSheet>
  );
}
